import React from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { joinCss } from "../helpers/utils";

import appClasses from "../App.module.scss";
import classes from "./EnFaqButton.module.scss";

function enFaqButton(props) {
  return (
    <Row>
      <Col
        sm="6"
        md="4"
        lg="3"
        xl="2"
        className={joinCss(
          classes.headerButton,
          appClasses["right-align-div"],
          "offset-9"
        )}
      >
        <Link
          className={classes.faqLink}
          to={{
            pathname: "/FAQEn"
          }}
        >
          FAQ In English
        </Link>
      </Col>
    </Row>
  );
}

export default enFaqButton;
